import { useEffect, useState } from "hono/jsx";
import { state } from "../client/_systems/state.ts";

export function LoadingScreen() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(state.isLoading);

    const handleLoading = (e: CustomEvent) => {
      setVisible(e.detail);
    };

    document.addEventListener("attack:loading", handleLoading as EventListener);
    return () =>
      document.removeEventListener(
        "attack:loading",
        handleLoading as EventListener,
      );
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black z-[10000] flex items-center justify-center text-white">
      <div className="flex flex-col items-center gap-4">
        <h2 className="text-3xl font-bold animate-pulse">LOADING...</h2>
        <div className="w-64 h-2 bg-gray-800 rounded overflow-hidden">
          <div className="h-full bg-green-500 animate-[pulse_1s_ease-in-out_infinite] w-full origin-left">
          </div>
        </div>
      </div>
    </div>
  );
}
